import { observer } from 'mobx-react-lite'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { BindInputPropsProps, ConfigString } from 'reusable/mobx-store-utils/form-handlers/new/form-handler'

interface TextFieldEmailProps extends Omit<TextFieldProps, 'onChange' | 'value'> {
   ip: BindInputPropsProps<ConfigString>
}

export default observer(function TextFieldEmail(props: TextFieldEmailProps) {
   const { ip, ...otherProps } = props

   const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // Remove all spaces and lowercase
      const cleanedEmail = e.target.value.replace(/\s+/g, '').toLowerCase()
      ip.onChange({ ...e, target: { ...e.target, value: cleanedEmail } })
   }

   return <TextField
      {...otherProps}
      {...ip}
      type="text" // Changed from email to text to allow for removing spaces
      onChange={handleChange}
   />
})